import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { DatePicker } from '../../../../../../../Components/DatePicker/index';
import { defaultMinDate } from 'Config';

export const DateRange = () => {
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const maxDateLimit = new Date();
  maxDateLimit.setMonth(maxDateLimit.getMonth() + 6); // 6 Months future limitation

  const startDateHandler = (date: Date | null) => {
    if (date && !isNaN(date.getTime())) {
      dispatchAdvancedSearch({
        type: 'REQUEST_DATE_RANGE',
        payload: {
          value: {
            start: new Date(date),
            end: advancedSearch.dateRange.end,
            isYear: false,
          },
        },
      });
    }
  };

  const endDateHandler = (date: Date | null) => {
    if (date && !isNaN(date.getTime())) {
      dispatchAdvancedSearch({
        type: 'REQUEST_DATE_RANGE',
        payload: {
          value: {
            start: advancedSearch.dateRange.start,
            end: new Date(date),
            isYear: false,
          },
        },
      });
    }
  };

  return (
    <>
      <DatePicker
        value={
          advancedSearch.dateRange.start
            ? new Date(advancedSearch.dateRange.start)
            : null
        }
        label={
          Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.fromDate
        }
        maxDate={
          advancedSearch.dateRange.end
            ? new Date(advancedSearch.dateRange.end)
            : maxDateLimit
        }
        onChange={startDateHandler}
        minDate={defaultMinDate}
      />
      <DatePicker
        value={
          advancedSearch.dateRange.end
            ? new Date(advancedSearch.dateRange.end)
            : null
        }
        label={
          Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch.toDate
        }
        minDate={
          advancedSearch.dateRange.start
            ? new Date(advancedSearch.dateRange.start)
            : undefined
        }
        maxDate={maxDateLimit}
        onChange={endDateHandler}
      />
    </>
  );
};
